import * as angular from 'angular';
import './footer.scss';
import { Component } from 'ng-metadata/core';


/**
 * @ngdoc directive
 * @name mwMediaContactDocumentFooter
 * @module mw.components.contentDocuments

 *
 * @description
 * `<mw-media-contact-document-footer>`
 *
 * @usage
 * <hljs hljs-language="html">
 * </hljs>
 *
 */
@Component({
    selector: 'mw-media-contact-document-footer',
    template: `
        <ng-transclude
            layout="row"
            ng-transclude-slot="mwContentDocumentActionTrigger"
            flex="noshrink"
            class="mw-media-contact-document-footer mw-media-contact-document-footer__triggers">
        </ng-transclude>
    `,
    legacy: {
        transclude: {
            mwContentDocumentActionTrigger: '?mwContentDocumentActionTrigger',
        }
    }
})
export class MediaContactDocumentFooterComponent {

}



// WEBPACK FOOTER //
// ./src/lib/components/content-documents/media-contact-document/footer/footer.component.ts